import clsx from 'clsx';
import { PropsWithChildren } from 'react';
import { LinkProps, useLocation } from 'react-router';

import Button, { ButtonProps } from '@/componentsv2/Button';

import isNavItemActive from './isNavItemActive';

const Item = ({
  children,
  hasNotification,
  icon,
  path,
  onClick,
}: PropsWithChildren<{
  icon: ButtonProps['startIcon'];
  path?: LinkProps['to'];
  onClick?: (e: React.MouseEvent<HTMLButtonElement | HTMLAnchorElement>) => void;
  hasNotification?: boolean;
}>) => {
  const { pathname } = useLocation();
  // Shared with `MobileItem`. Read the helper before adding a nav item nested
  // under another item's path: the rule marks both of them active.
  const isActive = isNavItemActive(pathname, path);

  return (
    <li className="relative">
      <Button
        to={path}
        onClick={onClick}
        variant="tertiary"
        size="small"
        startIcon={icon}
        startIconClassName="access-navbar-item-icon"
        aria-current={isActive ? 'page' : undefined}
        className={clsx(
          'access-navbar-item py-8',
          isActive
            ? 'rounded-sm bg-brand-light !font-semibold !text-brand-light-ink'
            : '!text-on-surface-secondary hover:!text-on-surface'
        )}
      >
        {children}
      </Button>
      {hasNotification ? (
        <span className="access-navbar-item absolute left-20 top-10 h-5 w-5 rounded-sm bg-yellow-500" />
      ) : null}
    </li>
  );
};

export default Item;
